export default __webpack_public_path__ + "static/media/sentinel-ble-3-pack.93b825a1.jpg";